
export default {
  props: {
    size: {
      default: 50,
    },
    value: { default: 0 },
    max: { default: 0 },
    stroke: { default: 10 },
  },

  computed: {
    percentage() {
      if (!this.max) {
        return 0;
      }
      let t = (this.size * 6.3)  - (((this.size * 6.3) * (this.value/this.max)*100)/100);
      return t<0?0:t;
    },
  },
};
